import { useState } from "react";
import { usePollutantActions } from "./usePollutantActions";

type ConfirmActionType = {
    type: "delete";
    pollutantId: string;
    pollutantName: string;
};

export const useConfirmationDialog = (onSuccess: () => void) => {
    const [isOpen, setIsOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState<ConfirmActionType | null>(null);
    const { handleDelete, isLoading } = usePollutantActions();

    const openDialog = (action: ConfirmActionType) => {
        setConfirmAction(action);
        setIsOpen(true);
    };

    const closeDialog = () => {
        setIsOpen(false);
        setTimeout(() => setConfirmAction(null), 200);
    };

    const handleConfirm = async () => {
        if (!confirmAction) return;

        try {
            if (confirmAction.type === "delete") {
                await handleDelete(confirmAction.pollutantId);
            }
            onSuccess();
            closeDialog();
        } catch (error) {
            console.error(`Error ${confirmAction.type} pollutant:`, error);
        }
    };

    return {
        isOpen,
        confirmAction,
        isLoading,
        openDialog,
        closeDialog,
        handleConfirm,
    };
}; 